import { Box, Flex } from 'mds-web-ui'
import { ActiveLink } from 'mds-web-ui/components/Link/GatsbyLink'
import React from 'react'
import { ExternalLink } from 'react-feather'
import styled from 'styled-components'

import { CursorTimelapseVideo } from '../utils/TimelapseVideo/CursorTimelapseVideo'
import { Heading, fontSizes } from '../utils/Typography'
import { useDesktopBreakpoint } from '../utils/mediaQueries'

const StyledLink = styled(ActiveLink)({
  fontSize: 12,
  lineHeight: 1,
  color: 'inherit'
})

export const TimelapseVideo = ({ src, alt, ...props }) => {
  const isDesktop = useDesktopBreakpoint()

  return (
    <Flex width="100%" mt={4} flexDirection="column" gap={[4, 48]} {...props}>
      <Flex
        alignItems="center"
        justifyContent="center"
        gap={[3, 4]}
        px={[0, 3, 5]}
      >
        <Flex flex={1} height={1} bg="#dddddd" />
        <Flex flexDirection="column" alignItems="center">
          <StyledLink to="/support/flow/managing-your-documents/exporting/#timelapse-configuration">
            <Heading as="h2" animate={false} m={0} fontSize={fontSizes.copy}>
              <Flex
                as="span"
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <span>Timelapse</span>
                <Box as="span" css={{ opacity: 0.8 }}>
                  <ExternalLink />
                </Box>
              </Flex>
            </Heading>
          </StyledLink>
        </Flex>

        <Flex flex={1} height={1} bg="#dddddd" />
      </Flex>
      <Box
        width="100%"
        css={{
          position: 'relative'
        }}
      >
        <CursorTimelapseVideo
          src={src}
          alt={alt}
          height="auto"
          width="100%"
          autoplay={!isDesktop}
          aspectRatio="4 / 3"
        >
          {isDesktop ? (
            <Flex
              css={{
                position: 'absolute',
                borderRadius: 8,
                left: '50%',
                top: 20,
                zIndex: 1,
                opacity: 0.3,
                transition: 'opacity 240ms ease-out',
                transform: 'translateX(-50%)',
                userSelect: 'none',
                '&:hover': {
                  opacity: 1
                }
              }}
              bg="rgba(0, 0, 0, 0.5)"
              color="#fff"
              px={3}
              py={2}
            >
              Scrub left and right to see the timelapse
            </Flex>
          ) : null}
        </CursorTimelapseVideo>
      </Box>
    </Flex>
  )
}
